import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Badge, Button, Modal, Spinner } from 'react-bootstrap';
import Select from 'react-select';
import { DataManager } from '../../core/data-manager';
import { ApiManager } from '../../core/api-manager';
import { LanguageProvider } from '../../core/language-provider';
import { toast } from 'react-toastify';
import * as XLSX from 'xlsx';
import { LoginManager } from '../../core/login-manager';
import moment from 'moment/moment';
import { settings } from '../../config/settings';





export default function DataGridLastTdHook({ item, props, entity = null, refreshData }) {

    const navigate = useNavigate()
    const userInfo = LoginManager.getUserInfo()


    function goToCourseDetails(item) {
        navigate('/page/CourseDetailsV2?id=' + item.id)
    }
    function goToUserCourse(item) {
        navigate('/page/UserCourse?id=' + item.id)
    }


    async function exportReportPublication(item) {
        var body = {
            idPublication: item.id
        }

        var res = await ApiManager.sendAuthenticatedRequest('/custom/export_publication', body);
        console.log(res);
        if (res.success === 1) {
            const worksheet = XLSX.utils.json_to_sheet(res.body);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Lista utenti');
            XLSX.writeFile(workbook, item.title + '.xlsx');
        } else {
            toast.error(res.message)
        }
    }


    /* async function exportReportEvent(item){
        var body = {
            idEvent: item.id
        }

        var res = await ApiManager.sendAuthenticatedRequest('/custom/export_event', body);
        console.log(res);
        if(res.success === 1){
            const worksheet = XLSX.utils.json_to_sheet(res.body);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Lista utenti');
            XLSX.writeFile(workbook, item.name + '.xlsx');
        }else {
            toast.error(res.message)
        }
    } */

    async function exportReportCourse(item) {
        var body = {
            idCourse: item.id
        }
        var res = await ApiManager.sendAuthenticatedRequest('/custom/export_course', body);
        console.log(res);
        if (res.success === 1) {
            const worksheet = XLSX.utils.json_to_sheet(res.body);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Lista utenti');
            XLSX.writeFile(workbook, item.name + '.xlsx');
        } else {
            toast.error(res.message)
        }
    }


    const [showModal, setShowModal] = useState(null);

    function closeModal() {
        setShowModal(false)
    }

    function openModal() {
        setShowModal(true)
        console.log(item)
    }


    /* --- USER: cambio gruppo --- */
    const [showGroupsModal, setShowGroupsModal] = useState(false);
    const [groupsLoading, setGroupsLoading] = useState(false);
    const [groupsSaving, setGroupsSaving] = useState(false);
    const [allGroups, setAllGroups] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState(null);

    function extractCurrentGroupId(userObj) {
        if (!userObj) return null;
        var raw = userObj.idUserGroup;
        if (raw === null || typeof raw === 'undefined') return null;
        if (typeof raw === 'object') return raw.id || null;
        return raw;
    }

    async function openGroupsModal() {
        setShowGroupsModal(true);
        setGroupsLoading(true);
        try {
            const sorting = { field: 'name', order: 'ASC' };
            const groupsRes = await DataManager.getItems('user_group', 1, 1000, sorting);
            const userRes = await DataManager.getItem('user', item.id);

            var groupOptions = [];
            if (groupsRes && groupsRes.success === 1 && Array.isArray(groupsRes.body)) {
                groupOptions = groupsRes.body.map(g => ({ value: g.id, label: g.name }));
            }
            setAllGroups(groupOptions);

            var currentUser = (userRes && userRes.success === 1 && userRes.body && userRes.body[0]) || item;
            var currentId = extractCurrentGroupId(currentUser);
            var match = currentId ? groupOptions.find(opt => opt.value === currentId) : null;
            setSelectedGroup(match || null);
        } catch (err) {
            console.error(err);
            toast.error('Errore nel caricamento dei gruppi', { theme: 'colored' });
        } finally {
            setGroupsLoading(false);
        }
    }

    function closeGroupsModal() {
        if (groupsSaving) return;
        setShowGroupsModal(false);
        setSelectedGroup(null);
        setAllGroups([]);
    }

    async function saveUserGroups() {
        setGroupsSaving(true);
        try {
            var body = {
                idUser: item.id,
                idUserGroup: selectedGroup ? selectedGroup.value : null
            };
            var res = await ApiManager.sendAuthenticatedRequest('/custom/update_user_groups', body);
            if (res && res.success === 1) {
                toast.success('Gruppo aggiornato con successo', { theme: 'colored' });
                setShowGroupsModal(false);
                setSelectedGroup(null);
                setAllGroups([]);
                if (refreshData) refreshData();
            } else {
                toast.error((res && res.message) || 'Errore nell\'aggiornamento del gruppo', { theme: 'colored' });
            }
        } catch (err) {
            console.error(err);
            toast.error('Errore di rete nell\'aggiornamento del gruppo', { theme: 'colored' });
        } finally {
            setGroupsSaving(false);
        }
    }

    async function completeEpisode() {
        console.log(item)
        var body = {
            isCompleted: 1
        }

        var res = await DataManager.updateItem('episode_user', body, item.id);
        if (res.success === 1) {
            toast.success("Episodio impostato come COMPLETATO con successo.", { theme: 'colored' })
            closeModal()
            refreshData()
            /* var sorting = {
                'field': 'id',
                'order': 'desc'
            }
            var constraints = [
                {
                    "fieldName": "idCourse",
                    "type": "value",
                    "value": item.idCourse
                },
                {
                    "fieldName": "author",
                    "type": "value",
                    "value": userInfo.id
                }
            ]
            var response = await DataManager.searchItemsSimple('episode_user', 1, 1000, sorting, '', [], constraints)
            if (response.success === 1) {
                const allCompleted = response && response.body.every(el => el.isCompleted === 1);
                if (allCompleted) {
                    const loadingToastId = toast.loading('Sto generando il certificato...', { theme: 'colored' });


                    var resCourse = await DataManager.getItem('course', item.idCourse);
                    if (resCourse.success === 1) {
                        var sorting = {
                            'field': 'id',
                            'order': 'desc'
                        }
                        var constraints = [
                            {
                                "fieldName": "defaultTemplate",
                                "type": "value",
                                "value": 1
                            }
                        ]
                        var resFile = await DataManager.searchItems('certificate_template', 1, 100, sorting, '', [], constraints);
                        console.log(resFile)
                        if (resFile.success === 1) {
                            const body = {
                                hash: resFile.body[0].file.hash,
                                name: userInfo.name,
                                surname: userInfo.surname,
                                nameCourse: resCourse.body[0].name,
                                notes: resCourse.body[0].certificateNotes,
                                //description: resCourse.body[0].certificateDescription,
                                date: moment().format('DD/MM/YYYY'),
                                episodes: resCourse.body[0].episodes,
                                numberEpisodes: resCourse.body[0].episodes.length,
                                //hour: Math.ceil(corsiCompletati[0].total_episodes_time / 60),
                                hour: 20,
                                cf: userInfo.cf || "",
                                episodesStart: moment(resCourse.body[0].episodes[0].episodeDate).format('DD/MM/YYYY'),
                                episodesEnd: moment(resCourse.body[0].episodes[resCourse.body[0].episodes.length - 1].episodeDate).format('DD/MM/YYYY'),
                            }

                            var responseWord = await ApiManager.sendAuthenticatedRequest('/public/get_certificate', body);
                            console.warn('CERTIFICATE', responseWord);

                            var sorting = {
                                'field': 'id',
                                'order': 'desc'
                            }
                            var constraints = [
                                {
                                    "fieldName": "hash",
                                    "type": "value",
                                    "value": responseWord.hash
                                }
                            ]
                            var res = await DataManager.searchItems('resource', 1, 100, sorting, '', [], constraints);
                            console.log(res)
                            if (res.success === 1) {
                                // Chiudo il toast di loading quando apro il certificato
                                toast.dismiss(loadingToastId)
                                window.open(settings.storageUrl + 'upload/' + res.body[0].entity + '/' + res.body[0].filename)
                            }
                        }
                    }
                }
            } */
        } else {
            toast.error("Errore nel completare l'episodio", { theme: 'colored' })
        }
    }



    if (entity !== null) {
        return (
            <>
                {userInfo.level === 1 ? <></> : <>
                    {(() => {
                        switch (entity) {
                            case 'sample': return (
                                <span>Test</span>
                            );
                            case 'course': return (
                                <>
                                    <Button onClick={() => goToCourseDetails(item)} size={'sm'} variant='outline-secondary'>Gestisci episodi</Button>
                                    <Button onClick={() => goToUserCourse(item)} size={'sm'} variant='outline-primary' className='ms-1'>Gestisci utenti</Button>
                                    <Button onClick={() => exportReportCourse(item)} size={'sm'} variant='outline-secondary' className='ms-1'>Scarica report</Button>
                                </>
                            );
                            case 'publication': return (
                                <>
                                    <Button onClick={() => navigate('/page/PublicationStats?id=' + item.id)} size={'sm'} variant='outline-secondary'>Vedi statistiche</Button>
                                    {/* <Button onClick={()=>exportReportPublication(item)} size={'sm'} variant='outline-secondary'>Scarica report</Button> */}
                                </>
                            );
                            case 'event': return (
                                <>
                                    <Button onClick={() => navigate('/page/EventStats?id=' + item.id)} size={'sm'} variant='outline-secondary'>Vedi statistiche</Button>
                                    {/* <Button onClick={()=>exportReportEvent(item)} size={'sm'} variant='outline-secondary'>Scarica report</Button> */}
                                </>
                            );
                            case 'user': return (
                                <>
                                    <Button onClick={openGroupsModal} size={'sm'} variant='outline-primary'>
                                        Cambia gruppo
                                    </Button>

                                    <Modal show={showGroupsModal} onHide={closeGroupsModal} size='lg' centered>
                                        <Modal.Header closeButton>
                                            <Modal.Title>Cambia gruppo utente</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <p className='mb-3'>
                                                Utente: <b>{item.name} {item.surname}</b>{item.email ? <> &mdash; <span className='text-muted'>{item.email}</span></> : null}
                                            </p>
                                            {groupsLoading ? (
                                                <div className='text-center p-4'>
                                                    <Spinner animation='border' variant='primary' size='sm' />
                                                </div>
                                            ) : (
                                                <>
                                                    <label className='form-label small text-muted'>Gruppo assegnato</label>
                                                    <Select
                                                        isClearable
                                                        isDisabled={groupsSaving}
                                                        options={allGroups}
                                                        value={selectedGroup}
                                                        onChange={(val) => setSelectedGroup(val || null)}
                                                        placeholder='Seleziona un gruppo...'
                                                        noOptionsMessage={() => 'Nessun gruppo disponibile'}
                                                    />
                                                    <small className='text-muted d-block mt-2'>
                                                        Sostituisce il gruppo attualmente assegnato all'utente.
                                                    </small>
                                                </>
                                            )}
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <Button variant='outline-secondary' onClick={closeGroupsModal} disabled={groupsSaving}>
                                                Annulla
                                            </Button>
                                            <Button variant='primary' onClick={saveUserGroups} disabled={groupsLoading || groupsSaving}>
                                                {groupsSaving ? (
                                                    <>
                                                        <Spinner animation='border' size='sm' className='me-2' />
                                                        Salvataggio...
                                                    </>
                                                ) : 'Salva'}
                                            </Button>
                                        </Modal.Footer>
                                    </Modal>
                                </>
                            );
                            case 'gyv_episode_user': return (
                                <>
                                    {item && item.isCompleted !== 1 ? <>
                                        <Button size={'sm'} variant='outline-success' onClick={() => openModal()}>Completa</Button>
                                    </> : null}



                                    <Modal show={showModal} onHide={closeModal} size='lg'>
                                        <Modal.Header closeButton>
                                            <Modal.Title>Completa episodio</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <p>Episodio: <b>{item.episode}</b></p>
                                            <p>Corso: <b>{item.course}</b></p>
                                            <p>Utente: <b>{item.name} {item.surname}</b></p>
                                            <br></br>
                                            Sei sicuro di voler impostare come completato questo episodio per questo utente?</Modal.Body>
                                        <Modal.Footer>
                                            <Button variant="outline-danger" onClick={closeModal}>
                                                Annulla
                                            </Button>
                                            <Button variant="success" onClick={() => completeEpisode()}>
                                                Completa
                                            </Button>
                                        </Modal.Footer>
                                    </Modal>
                                </>
                            );
                            default: return (
                                <></>
                            );
                        }
                    })()}
                </>}

            </>
        )
    }
    else {
        return (
            <></>
        )
    }
};
